import axios from 'axios';
import React, { useEffect } from 'react';
import { Alert, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { apiUrl } from '../config';
import { RedeemCustomerBookingShortLinkDto } from '../interfaces/appointments';
import { saveBookingAccessToken } from './bookingAccess';

function AppointmentBookingShortLink() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const [error, setError] = React.useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    if (!code) {
      navigate('/timebestilling-login', { replace: true });
      return;
    }

    axios
      .get<RedeemCustomerBookingShortLinkDto>(`${apiUrl}/appointments/customer/short-links/${encodeURIComponent(code)}/redeem`)
      .then((response) => {
        if (cancelled) {
          return;
        }

        saveBookingAccessToken(
          response.data.phone,
          response.data.registrationNumber,
          response.data.token,
          response.data.expiresAtUtc,
        );

        navigate(`/timebestilling/${response.data.phone}/${response.data.registrationNumber}`, {
          replace: true,
        });
      })
      .catch(() => {
        if (!cancelled) {
          setError('Lenken for direkte timebestilling er ugyldig eller utløpt.');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [code, navigate]);

  return (
    <Stack alignItems="center" sx={{ p: 2 }}>
      <Paper sx={{ p: 3, width: '100%', maxWidth: 480 }}>
        <Stack spacing={2} alignItems="center">
          {!error && (
            <>
              <CircularProgress />
              <Typography>Åpner timebestilling...</Typography>
            </>
          )}
          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </Paper>
    </Stack>
  );
}

export default AppointmentBookingShortLink;
